{
  "de": {
    "schoolClass": {
      "actions": {
        "leave": "Klassenraum verlassen"
      },
      "activityViewer": {
        "createdAt": "{dateTime} Uhr",
        "createdAtTwelveHour": "{dateTime}",
        "breadcrumb": {
          "activities": "Aktivitäten"
        },
        "navigation": {
          "previous": "Vorherige Aktivität",
          "next": "Nächste Aktivität"
        },
        "export": {
          "document": "Dokument sichern",
          "audio": "Audiodatei sichern",
          "image": "Bild sichern"
        },
        "placeholder": {
          "unknownPupil": "Unbekannt",
          "unknownWorksheet": "Unbekanntes Arbeitsblatt"
        },
        "worksheet": {
          "submission": "Abgabe: {worksheetName}",
          "goToDetailView": "Zur Detailansicht"
        },
        "pupilFeedback": {
          "submission": "Abgabe: {assignmentName}",
          "unknownAssignment": "Unbekannte Aufgabe",
          "averageScore": "ø Wert Abgabe:",
          "feedbackLabel": "Feedback",
          "goToDetailView": "Zur Detailansicht"
        },
        "error": {
          "loadingActivities": "Fehler beim Laden der Aktivitäten. Bitte versuchen Sie es erneut.",
          "activityNotFound": "Aktivität nicht gefunden."
        },
        "converter": {
          "additionalInfo": "Zusatzinfos und Zielgruppe",
          "source": "Quelle",
          "result": "Ergebnis",
          "noAudio": "Keine Audiodatei verfügbar",
          "noOutputText": "Kein Ausgabetext verfügbar",
          "labels": {
            "text": "Ergebnis",
            "transcript": "Transkript",
            "summary": "Zusammenfassung",
            "translation": "Übersetzung",
            "audio": "Audio",
            "podcast": "Podcast",
            "lecture": "Vorlesung",
            "dialog": "Dialog"
          }
        },
        "textEditor": {
          "untitled": "Unbenanntes Dokument"
        },
        "pinboardCard": {
          "noContent": "Diese Karte hat keinen Inhalt.",
          "goToCard": "Zur Karte"
        },
        "pinboardComment": {
          "noContent": "Dieser Kommentar hat keinen Inhalt.",
          "goToCard": "Zur Karte"
        },
        "pinboardList": {
          "description": "Diese Liste ordnet Karten auf einer Pinnwand und enthält selbst keine Inhalte.",
          "goToBoard": "Zur Pinnwand"
        },
        "surveyResponse": {
          "anonymous": "Keine Detailansicht verfügbar — Umfrage-Abgaben sind anonym.",
          "goToResponses": "Zur Ergebnis-Übersicht"
        },
        "wordEntry": {
          "wordCloudLabel": "in Wortwolke:",
          "goToWordCloud": "Zur Wortwolke"
        }
      },
      "activityContent": {
        "loading": "Inhalt wird geladen...",
        "notSupported": "Vorschau noch nicht verfügbar",
        "comingSoon": "Diese Tool-Vorschau wird bald verfügbar sein",
        "emptyState": "Keine Inhalte verfügbar",
        "errors": {
          "unauthorized": "Sie haben keine Berechtigung, diesen Inhalt anzusehen",
          "notFound": "Dieser Inhalt ist nicht mehr verfügbar",
          "loadFailed": "Inhalt konnte nicht geladen werden",
          "unexpected": "Ein unerwarteter Fehler ist aufgetreten"
        },
        "chat": {
          "emptyState": "Keine Nachrichten in dieser Konversation"
        },
        "textEditor": {
          "emptyState": "Dieses Dokument ist leer"
        },
        "worksheet": {
          "noContent": "Kein Inhalt zum Anzeigen"
        }
      },
      "activities": {
        "actions": {
          "downloadImage": "Bild herunterladen"
        },
        "labels": {
          "name": "Name",
          "content": "Inhalt",
          "project": "Projekt",
          "access": "Zugang",
          "createdAt": "Erstellt am",
          "viewActivity": "Aktivität ansehen"
        },
        "itemTitles": {
          "pinboardCard": "Neue Karte „{name}“",
          "pinboardList": "Neue Liste „{name}“",
          "pinboardComment": "Neuer Kommentar auf „{name}“",
          "surveyResponse": "Neue Abgabe „{name}“",
          "wordEntry": "Neuer Eintrag „{name}“"
        },
        "saveConversation": "Unterhaltung sichern",
        "saveDocument": "Dokument sichern",
        "saveResponse": "Abgabe sichern",
        "saveResult": "Ergebnis sichern",
        "sectionTitle": "Zuletzt angelegt",
        "projectSectionTitle": "Aktivitäten in diesem Projekt",
        "projectSectionTooltip": "Klicke auf eine Aktivität, um die Details zu öffnen. Abgaben und KI-Chatverläufe kannst du über das 3-Punkte-Menü einfach herunterladen.",
        "emptyState": "Hier gibt es noch keine Aktivitäten. Sobald du an einem Projekt arbeitest, kannst du hier deine Aktivitäten sehen.",
        "projectEmptyState": "In diesem Projekt gibt es noch keine Aktivitäten. Sobald deine Schüler*innen am Projekt arbeiten, erscheinen ihre Aktivitäten hier.",
        "filters": {
          "ariaLabel": "Aktivitäten filtern",
          "title": "Aktivitäten filtern",
          "all": "Alle",
          "access": {
            "title": "Zugang",
            "label": "Zugang auswählen…",
            "ariaLabel": "Nach Zugang filtern"
          },
          "content": {
            "title": "Inhalt",
            "label": "Inhalt"
          },
          "status": {
            "title": "Status",
            "label": "Status",
            "ariaLabel": "Nach Status filtern",
            "completed": "Abgeschlossen",
            "open": "Offen"
          },
          "timeframe": {
            "title": "Zeitraum",
            "label": "Zeitraum",
            "totalPeriod": "Gesamter Zeitraum",
            "last7Days": "Letzte 7 Tage",
            "last30Days": "Letzte 30 Tage",
            "thisYear": "Dieses Jahr ({year})",
            "lastYear": "Letztes Jahr ({year})",
            "customRange": "Zeitraum festlegen"
          }
        }
      },
      "activity": {
        "addPupil": "Zugang hinzufügen",
        "downloadCodes": "Liste anzeigen"
      },
      "alert": {
        "discardedMembershipTitle": "Du bist kein aktives Mitglied dieses Klassenraums mehr",
        "discardedMembershipBody": "Alle deine Projekte wurden beendet. Ohne aktive Mitgliedschaft kannst du keine neuen Projekte anlegen.",
        "discardedMembershipProjectBody": "Ohne aktive Mitgliedschaft kannst du dieses Projekt nicht mehr öffnen. Tritt dem Klassenraum erneut bei, um wieder Zugriff zu erhalten.",
        "sharedClassroomAccessItem1": "Schüler*innen loggen sich auf <a href='https://go.fobizz.com' target='_blank'>go.fobizz.com</a> ein. Hier findest du alle Zugänge, falls ein*e Schüler*in den Code verloren hat.",
        "sharedClassroomAccessItem2": "<strong>Achtung</strong>: Alle Lehrkräfte nutzen dieselben Codes für Schüler*innen eines geteilten Klassenraums. Achte darauf, <strong>Änderungen</strong> in der Liste unbedingt mit allen Kolleg*innen <strong>abzustimmen</strong>, die diesen Klassenraum gemeinsam nutzen.",
        "sharedClassroomAccessTitle": "Zugangsverwaltung im geteilten Klassenraum"
      },
      "classroom": {
        "create": "Klassenraum anlegen",
        "createDescription": "Teile Arbeitsaufträge mit deinen Schüler*innen und stelle KI-Tools und Materialien für die Bearbeitung zur Verfügung.",
        "links": {
          "new": "Klassenraum anlegen",
          "back": "Zurück",
          "discardedProjects": "Beendete Projekte",
          "pausedProjectsTab": "Pausierte Projekte",
          "activeProjects": "Aktuelle Projekte",
          "projects": "Projekte",
          "currentProject": "Projekt",
          "members": "Lehrkräfte",
          "accessCodes": "Zugänge"
        },
        "projectFilter": {
          "ariaLabel": "Projekte nach Status filtern",
          "all": "Alle",
          "active": "Aktiv",
          "paused": "Pausiert",
          "ended": "Beendet"
        },
        "info": {
          "classroom": {
            "heading": "Zugänge zum Klassenraum datenschutzkonform verwalten",
            "listItems": "<ol><li>Liste ausdrucken und zuordnen: vermerke analog auf Papier, wer wer ist.</li><li>Zugangscodes verteilen: ein Code pro Person und Schuljahr.</li><li>Zugang erhalten: Schüler*innen loggen sich auf <a href='https://go.fobizz.com'>go.fobizz.com</a> ein.</li></ol>",
            "manage": "Verwalten",
            "showAccessCodes": "Zugangscodes anzeigen"
          },
          "index": {
            "body": "Mit den Klassenräumen arbeiten Schüler*innen selbstständig und sicher mit digitalen Tools.<br>Du hast die Wahl zwischen zwei Varianten:",
            "heading": "Tools und KI für deine Klasse",
            "option1": "<strong class=\"fw-semibold\">Klassenraum für 1 Jahr</strong><br>Mehrere Projekte, individueller Zugangscode pro Schüler*in, Zusammenarbeit mit weiteren Lehrkräften im selben Klassenraum, automatische Löschung nach 365 Tagen",
            "option2": "<strong class=\"fw-semibold\">Klassenraum für 24 h</strong><br>Ein einzelnes Projekt, einheitlicher Zugangslink für alle, automatische Löschung nach 24 Stunden"
          }
        },
        "labels": {
          "activateControls": {
            "hours24": "24 Std",
            "hours24WithMaximum": "24 Std",
            "hours24Full": "24 Stunden",
            "oneMonthWithMaximum": "1 Monat",
            "extend": "Verlängern",
            "reactivate": "Reaktivieren",
            "stop": "Pausieren"
          },
          "model": {
            "name": "Name des Klassenraums",
            "namePlaceholder": "Name eingeben...",
            "studentAccess": "Zugänge Schüler*innen"
          },
          "school": "Schule",
          "shareHint": "Den Klassenraum kannst du nach dem Erstellen mit Kolleg*innen teilen. Den Einladungslink findest du im Bereich „Lehrkräfte“.",
          "studentAccessTooltip": "Anzahl der Schüler*innen, die gleichzeitig in diesem Klassenraum arbeiten können. Jede Person erhält einen individuellen Zugangscode."
        },
        "indexTitle": "Klassenräume",
        "pageTitle": "Meine Klassenräume",
        "pupil": {
          "loggedInAs": "Angemeldet als",
          "logout": "Abmelden"
        }
      },
      "confirmDialog": {
        "deletePupil": {
          "confirmButton": "Löschen",
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Der Zugangscode wird gelöscht und kann nicht mehr zum Anmelden genutzt werden.",
          "title": "Zugang löschen?"
        },
        "deleteTemplate": {
          "confirmButton": "Löschen",
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Die Vorlage wird dauerhaft gelöscht und steht für neue Projekte nicht mehr zur Verfügung.",
          "title": "Projektvorlage löschen?"
        },
        "discardProject": {
          "confirmButton": "Löschen",
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Das Projekt wird dauerhaft gelöscht.",
          "title": "Projekt löschen?"
        },
        "finishProject": {
          "confirmButton": "Beenden",
          "text": "Das Projekt wird beendet und ins Archiv verschoben. Du findest es danach unter den archivierten Projekten des Klassenraums.",
          "title": "Projekt beenden?"
        },
        "leave": {
          "confirmButton": "Verlassen",
          "text": "Du hast danach keinen Zugriff mehr auf den Klassenraum und seine Inhalte.",
          "title": "Klassenraum verlassen?"
        },
        "saveAsTemplate": {
          "confirmButton": "Speichern",
          "text": "Das Projekt wird als Vorlage gespeichert und dabei vom Klassenraum getrennt.",
          "title": "Projekt als Vorlage speichern?"
        }
      },
      "download": {
        "abbreviation": "Kürzel",
        "accessCode": "Zugangscode",
        "accessCodesForClass": "Zugangscodes für ",
        "accessCreationInstruction": "Auf app.fobizz.com kannst du in der Übersicht dieses Klassenraums einfach weitere Zugänge anlegen.",
        "accessListForClass": "Zugangsliste für",
        "documentNotice": "Dieses Dokument ist nur für deine Unterlagen bestimmt und muss vertraulich behandelt werden. Teile außerdem niemals personenbezogene Daten deiner Schüler*innen online.",
        "goToInstruction": "Gehe zu: ",
        "needMoreAccess": "Benötigst du weitere Zugänge?",
        "note": "Notiz",
        "yourAbbreviation": "Dein Kürzel:",
        "yourAccessCode": "Dein Zugangscode: "
      },
      "errors": {
        "createFailed": "Projekt konnte nicht erstellt werden."
      },
      "flash": {
        "accessCodeCopied": "Zugangscode in die Zwischenablage kopiert",
        "createSuccess": "Projekt wurde erfolgreich erstellt.",
        "deactivatePupilFailure": "Zugang konnte nicht deaktiviert werden.",
        "deactivatePupilSuccess": "Zugang wurde erfolgreich deaktiviert.",
        "deactivateTeacherFailure": "Zugang der Lehrkraft konnte nicht deaktiviert werden.",
        "deactivateTeacherSuccess": "Zugang der Lehrkraft wurde erfolgreich deaktiviert.",
        "deletePupilFailure": "Zugang konnte nicht gelöscht werden.",
        "deletePupilSuccess": "Zugang wurde erfolgreich gelöscht.",
        "leaveFailure": "Fehler beim Verlassen des Klassenraums.",
        "leaveSuccess": "Du hast den Klassenraum erfolgreich verlassen.",
        "finishProjectSuccess": "Projekt erfolgreich beendet.",
        "pauseProjectSuccess": "Projekt erfolgreich pausiert.",
        "resumeProjectSuccess": "Projekt erfolgreich reaktiviert.",
        "extendProjectSuccess": "Projekt erfolgreich verlängert.",
        "restoreProjectSuccess": "Projekt erfolgreich wiederhergestellt.",
        "shareProjectSuccess": "Dein Projekt wurde erfolgreich geteilt.",
        "shareProjectFailure": "Das Projekt konnte nicht geteilt werden.",
        "privateItem": "Die Freigabeeinstellungen für diesen Inhalt wurden aktualisiert.",
        "reactivatePupilFailure": "Zugang konnte nicht reaktiviert werden.",
        "reactivatePupilSuccess": "Zugang wurde erfolgreich reaktiviert.",
        "reactivateTeacherFailure": "Zugang der Lehrkraft konnte nicht reaktiviert werden.",
        "reactivateTeacherSuccess": "Zugang der Lehrkraft wurde erfolgreich reaktiviert.",
        "regenerateTokenFailure": "Zugangscode konnte nicht neu generiert werden.",
        "regenerateTokenSuccess": "Zugangscode wurde erfolgreich neu generiert.",
        "remixedItem": "Dieser KI-Assistent wurde für dich geremixed und in dein Konto kopiert.",
        "updateSchoolClassSuccess": "Klassenraum wurde erfolgreich aktualisiert.",
        "copyError": "Fehler beim Kopieren in die Zwischenablage.",
        "noAccessCode": "Kein Zugangscode vorhanden.",
        "deleteFailed": "Projekt konnte nicht gelöscht werden.",
        "createFromTemplateFailed": "Projekt konnte nicht aus Vorlage erstellt werden.",
        "saveAsTemplateSuccess": "Projekt wurde erfolgreich als Vorlage gespeichert.",
        "saveAsTemplateFailed": "Projekt konnte nicht als Vorlage gespeichert werden.",
        "deleteTemplateSuccess": "Vorlage wurde erfolgreich gelöscht.",
        "deleteTemplateFailed": "Vorlage konnte nicht gelöscht werden.",
        "updateTemplateSuccess": "Projektvorlage wurde aktualisiert.",
        "updateTemplateFailed": "Projektvorlage konnte nicht aktualisiert werden."
      },
      "hints": {
        "aiChatAlert": "Mit dem KI Chat können Schüler*innen auch eigene KI-Assistenten erstellen.",
        "projectFiles": "Lade Dateien hoch, die deine Schüler*innen im Projekt ansehen und herunterladen können.",
        "projectItems": "Teile bis zu 10 Materialien/Assistenten mit Schüler*innen.",
        "projectTools": "Aus Datenschutz und technischen Gründen können aktuell nur die angegebenen Tools für Schüler*innen freigegeben werden."
      },
      "labels": {
        "inactivePupil": "Zugang deaktiviert",
        "owner": "Admin",
        "pupilName": "Name",
        "showQrCode": "QR-Code anzeigen",
        "activity": "Aktivität",
        "totalToolsCount": "Aktivität | Aktivitäten",
        "createdAt": "Erstellt am"
      },
      "members": {
        "actions": {
          "discard": "Zugang deaktivieren",
          "undiscard": "Zugang reaktivieren"
        },
        "status": {
          "header": "Zugang",
          "active": "Zugang aktiv",
          "deactivated": "Zugang deaktiviert"
        },
        "empty": "Noch keine Lehrkräfte hinzugefügt",
        "schoolAccessExpired": {
          "title": "Einladungen nicht möglich",
          "text": "Dieser Klassenraum gehört zur Schule „{companyName}“, für die keine aktive Lizenz für geteilte Klassenräume mehr besteht. Kolleg*innen können daher nicht mehr eingeladen werden.",
          "textWithoutSchool": "Für diesen Klassenraum besteht keine aktive Lizenz für geteilte Klassenräume mehr. Kolleg*innen können daher nicht mehr eingeladen werden."
        },
        "invite": {
          "title": "Lehrkräfte zum Klassenraum einladen",
          "titleShort": "Lehrkräfte einladen",
          "tooltip": "Nur Klassenraum-Zugang. Projekte nicht inbegriffen.",
          "retry": "Einladungslink generieren",
          "regenerate": "Neu generieren",
          "showQrCode": "QR-Code anzeigen",
          "qrCodeTitle": "QR-Code",
          "qrCodeAlt": "QR-Code für den Einladungslink",
          "confirmRegenerate": {
            "title": "Einladungslink neu generieren",
            "text": "Hier kannst du den Einladungslink für den Klassenraum neu generieren. Bitte beachte, dass der alte Link danach ungültig wird.",
            "confirm": "Ja, neu generieren"
          },
          "flash": {
            "generateFailure": "Einladungslink konnte nicht erstellt werden.",
            "regenerateSuccess": "Einladungslink wurde neu generiert.",
            "regenerateFailure": "Einladungslink konnte nicht neu generiert werden."
          }
        }
      },
      "modals": {
        "deleteConfirmation": {
          "confirmButton": "Löschen",
          "projectsInfo": "alle aktiven Projekte (aktuell {count})",
          "subtitle": "Möchtest du den Klassenraum {schoolClassName} wirklich löschen?",
          "text": "Der Klassenraum wird für alle teilnehmenden Lehrkräfte gelöscht.",
          "textWithProjects": "Der Klassenraum wird für alle teilnehmenden Lehrkräfte gelöscht. Außerdem werden {projectsInfo} automatisch beendet.",
          "title": "Klassenraum löschen?"
        }
      },
      "project": {
        "create": "Neues Projekt anlegen",
        "defaults": {
          "descriptionPlaceholder": "Hier kannst du deinen Arbeitsauftrag näher beschreiben.",
          "name": "Projektname",
          "projectNamePlaceholder": "Aufgabenname eingeben..."
        },
        "heading": {
          "noProject": "Zeit für eine kleine Pause",
          "createFromTemplate": "KI Einführung für Schüler*innen"
        },
        "share": {
          "button": "Freigeben",
          "dialogTitle": "Teile dieses Projekt mit deinen Kolleg*innen",
          "dialogDescription": "Hier kannst du Lehrkräfte aus dem Klassenraum {schoolClassName} zum Projekt {projectName} hinzufügen.",
          "dialogDescriptionNoClass": "Hier kannst du Lehrkräfte zum Projekt {projectName} hinzufügen."
        },
        "errors": {
          "fileAttachFailed": "„{filename}“ konnte nicht zum Projekt hinzugefügt werden. Bitte prüfe Dateityp und Dateigröße.",
          "fileRemoveFailed": "Die Datei konnte nicht entfernt werden. Bitte versuche es erneut.",
          "imageUpdateFailed": "Das Projektbild konnte nicht gespeichert werden. Bitte versuche es erneut.",
          "itemLoadFailed": "Das zu teilende Material konnte nicht geladen werden. Du kannst es über „Inhalte hinzufügen“ auswählen.",
          "itemUnlockFailed": "Das Projekt wurde erstellt, aber die Freigabeeinstellungen des Materials konnten nicht aktualisiert werden. Bitte prüfe sie im Material."
        },
        "hints": {
          "dropFile": "Per Drag & Drop hier reinziehen oder Datei auswählen.",
          "projectItemsLimitReached": "Du hast die maximale Anzahl von 10 Materialien erreicht. Lösche Materialien, um neue hinzuzufügen."
        },
        "labels": {
          "activeShort": "Aktiv für",
          "chatFrom": "Chat vom",
          "createdBy": "Von {name}",
          "dayLabel": "Tag | Tage",
          "description": "Arbeitsauftrag",
          "completed": "Abgeschlossen",
          "discardedAt": "Projekt beendet",
          "enabledTools": "Freigegebene Tools",
          "members": "Lehrkraft hinzufügen",
          "membersPlaceholder": "Auswählen...",
          "membersNoOptions": "Bitte zuerst Lehrkräfte dem Klassenraum hinzufügen",
          "membersAllAdded": "Es wurden bereits alle Lehrkräfte des Klassenraums hinzugefügt",
          "membersTooltip": "Lehrkräfte, die zu diesem Klassenraum eingeladen wurden, können hier dem Projekt hinzugefügt werden.",
          "end": "Projekt beenden",
          "feedbackGiven": "Feedback gegeben",
          "files": "Dateien",
          "history": "Verläufe und Abgaben",
          "replaceImage": "Bild ersetzen",
          "teachers": "Lehrkräfte",
          "restore": "Projekt wiederherstellen",
          "hourLabel": "Std",
          "noProject": "Gerade gibt es hier keine Aufgaben für dich.",
          "noArchivedProjects": "Noch keine beendeten Projekte vorhanden.",
          "on": "am",
          "pausedPupil": "Deine Lehrkraft kann das Projekt wieder aktivieren.",
          "projectItemResponseSubmissions": "{count} Abgabe | {count} Abgaben",
          "projectActive": "Projekt aktiv",
          "projectActiveFor": "Projekt aktiv für",
          "projectItems": "Materialien und Assistenten",
          "projectPaused": "Projekt pausiert",
          "pausedShort": "Pausiert",
          "projectPausedSentence": "Projekt ist pausiert.",
          "pupil": {
            "accessCode": "Zugangscode:",
            "deactivate": "Zugang deaktivieren",
            "delete": "Zugang löschen",
            "downloadList": "Liste anzeigen",
            "reactivate": "Zugang reaktivieren",
            "regenerateToken": "Zugangscode neu generieren"
          },
          "draftFrom": "Entwurf vom",
          "submittedOn": "Abgegeben am"
        },
        "links": {
          "new": "Projekt anlegen",
          "newEmpty": "Leeres Projekt",
          "newFromTemplate": "Projekt aus Vorlage anlegen",
          "open": "Projekt öffnen",
          "remove": "Projekt löschen",
          "saveAsTemplate": "Als Vorlage speichern"
        },
        "paragraphs": {
          "createTile": "Teile einen Arbeitsauftrag und gib bestimmte Tools und Materialien dafür frei.",
          "createFromTemplateTile": "Nutze unseren vorbereiteten Einführungskurs, um Grundlagenwissen zu KI Kompetenz zu vermitteln.",
          "templateModalDescription": "Wähle eine Vorlage aus und erhalte ein vorbereitetes Projekt für deinen Klassenraum.",
          "pupil": {
            "empty": "Es gibt noch keine Teilnehmenden in diesem Klassenraum. Teile den Zugangslink, um loszulegen."
          }
        },
        "picker": {
          "addButton": "Inhalte hinzufügen",
          "assistantCatalog": {
            "empty": "Keine Assistenten gefunden.",
            "errorLoading": "Die Assistenten konnten nicht geladen werden.",
            "tabLabel": "Assistentenkatalog"
          },
          "dialogTitle": "Inhalte hinzufügen",
          "limitHint": "Maximal {max} Inhalte pro Projekt. Wähle weniger aus.",
          "myContent": {
            "tabLabel": "Meine Ablage"
          },
          "searchPlaceholder": "Inhalte durchsuchen..."
        },
        "pupil": {
          "enabledTools": "Freigegebene Tools",
          "warning": {
            "text": "{title} Deine Lehrkraft kann jederzeit deinen aktuellen Arbeitsstand einsehen.",
            "title": "Gut zu wissen:"
          }
        },
        "shareAlertHeadline": "Zugang für alle Teilnehmenden:"
      },
      "projectTemplates": {
        "heading": "Projektvorlagen",
        "breadcrumb": "Projektvorlagen"
      },
      "consentModal": {
        "acknowledge": {
          "hint": "Tippe hier, um zu bestätigen",
          "label": "Alles klar, habe ich verstanden"
        },
        "start": "Los geht's"
      },
      "inviteRedeem": {
        "title": "Einladung zum Klassenraum {name}",
        "body": "{inviter} hat dich in den Klassenraum {name} eingeladen.",
        "bodyNoInviter": "Du wurdest in den Klassenraum {name} eingeladen.",
        "join": "Klassenraum beitreten",
        "decline": "Ablehnen",
        "invalidTitle": "Dieser Einladungslink ist nicht mehr gültig.",
        "invalidSubtitle": "Bitte das Kollegium um einen neuen Einladungslink.",
        "expiredTitle": "Der Link ist abgelaufen",
        "expiredSubtitle": "Die Person, die den Klassenraum verwaltet, kann dir den aktuellen Link senden.",
        "expiredConfirm": "OK",
        "errorTitle": "Die Einladung konnte nicht geladen werden.",
        "errorSubtitle": "Bitte überprüfe deine Verbindung und versuche es erneut.",
        "retry": "Erneut versuchen",
        "backToOverview": "Zu „Organisieren“",
        "licenseActivateTitle": "1/2 Lizenzgruppe aktivieren",
        "licenseActivateBody": "{inviter} hat dich in den Klassenraum {name} eingeladen.{break}Für die Nutzung der Klassenräume benötigst du eine {license}.",
        "licenseActivateBodyNoInviter": "Du wurdest in den Klassenraum {name} eingeladen.{break}Für die Nutzung der Klassenräume benötigst du eine {license}.",
        "licenseActivateDifferentSchoolBody": "{inviter} hat dich in den Klassenraum {name} eingeladen.{break}Deine aktive Lizenz gehört nicht zur Schule des Klassenraums.",
        "licenseActivateDifferentSchoolBodyNoInviter": "Du wurdest in den Klassenraum {name} eingeladen.{break}Deine aktive Lizenz gehört nicht zur Schule des Klassenraums.",
        "licenseCodeLabelForSchool": "Hast du einen 8-stelligen Aktivierungscode für die Lizenzgruppe {school}?",
        "licenseWrongSchoolTitle": "Der von dir verwendete Aktivierungscode ist für eine andere Lizenzgruppe gültig.",
        "licenseWrongSchoolBody": "Für die Klassenraumeinladung von {inviter} benötigst du den Aktivierungscode für die Lizenzgruppe {school}.",
        "licenseWrongSchoolBodyNoInviter": "Für die Klassenraumeinladung benötigst du den Aktivierungscode für die Lizenzgruppe {school}.",
        "licenseWrongSchoolBodyNoSchool": "Für die Klassenraumeinladung von {inviter} benötigst du den Aktivierungscode für die richtige Lizenzgruppe.",
        "licenseJoinTitle": "2/2 Klassenraum beitreten",
        "licenseJoinBody": "{inviter} hat dich in den Klassenraum {name} eingeladen. Tritt jetzt dem Klassenraum bei, für die gemeinsame Nutzung von Projekten.",
        "licenseJoinBodyNoInviter": "Du wurdest in den Klassenraum {name} eingeladen. Tritt jetzt dem Klassenraum bei, für die gemeinsame Nutzung von Projekten.",
        "licenseName": "fobizz Lizenz",
        "licenseCodeLabel": "Hast du bereits einen 8-stelligen Aktivierungscode?",
        "activateLicense": "Lizenz aktivieren",
        "moreAboutGroupLicense": "Mehr zur Gruppenlizenz",
        "groupLicenseUrl": "https://fobizz.com/de/angebote-fuer-schulen-und-gruppen/",
        "flash": {
          "joinSuccess": "Einladung angenommen – Willkommen im Klassenraum {name}",
          "joinFailure": "Beitritt fehlgeschlagen. Bitte versuche es erneut.",
          "declined": "Klassenraum Einladung wurde abgelehnt.",
          "alreadyMember": "Du bist bereits Mitglied des Klassenraums {name}.",
          "differentSchool": "Dieser Code gehört zu einer anderen Schule. Ein Beitritt zu diesem Klassenraum ist damit nicht möglich.",
          "licenseActivated": "Lizenzgruppe {group} erfolgreich aktiviert."
        }
      }
    }
  }
}
